/* istanbul ignore file */
import React from 'react';
import { SecurityContextTemplate, SecurityContextCommonProps } from 'framework/authorization';
import useFinanceService from 'domain/people/employee/finance/shared/financeService';
import { useFinanceId } from 'domain/people/employee/finance/financeRouting';

const FinanceContext = ({ permissionToCheck, children }: SecurityContextCommonProps) => {
  const { getPermissions } = useFinanceService();
  const CONTEXT_NAME = 'Finance_CONTEXT';
  const financeId = useFinanceId();

  return (
    <SecurityContextTemplate
      getPermissionsFunc={() => getPermissions(financeId)}
      permissionToCheck={permissionToCheck}
      contextName={CONTEXT_NAME}
    >
      {children}
    </SecurityContextTemplate>
  );
};

export default FinanceContext;
